import { Flex, Spinner, Text } from "@chakra-ui/react";
import React from "react";

interface LoadingIndicatorProps {
  message?: string;
}

export default function LoadingIndicator(props: LoadingIndicatorProps) {
  return (
    <Flex
      pos={"absolute"}
      left={0}
      right={0}
      top={0}
      bottom={0}
      bgColor={"rgba(0, 0, 0, 0.25)"}
      zIndex={1000}
      css={{ backdropFilter: "blur(16px)" }}
      flexDir="column"
    >
      <Flex
        alignItems={"center"}
        justify="center"
        width="calc(100vw - 300px)"
        height="100vh"
        flexDir={"column"}
        gap={16}
      >
        <Spinner size="xl" color="brand.500" />
        {props.message && (
          <Text fontSize={"2xl"} fontWeight="medium" color={"gray.900"}>
            {props.message}...
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
